import { EbCostCenter } from './costCenter';
import { EbParty } from './party';
import { EbUser } from './user';
import { EbCategorie } from './categorie';
import { EbCommande } from './commande';
import { EbMarchandise } from './marchandise';
import { FichierJoint } from "./fichiersJoint"
import { ExEbDemandeTransporteur } from './demandeTransporteur';
import { EbCompagnieCurrency } from './compagnieCurrency';
import { MTEnum } from './mtEnum';
import { EbTracing } from './tracing';
import { EbEtablissement } from './etablissement';
import { IField } from './customField';
import { keyValue } from '../utils/statique';
import { EcCurrency } from './currency';
import { DemandeStatus, TypeFlux } from '../utils/enumeration';

export class EbDemande {

	ebDemandeNum: number;
	nbReminderSent: number;
	ebPartyOrigin: EbParty;
	ebPartyNotif: EbParty;
	ebPartyDest: EbParty;
	dateReadyForPickup: Date;
	dateMaj: Date;
	datePickup: Date;
	dateEnvoiQuotation: Date;
	insurance: boolean;
	insuranceValue: number;
	city: string;
	commentMytower: string;
	commentChargeur: string;
	dateOfGoodsAvailability: Date;
	dateOfArrival: Date;
	xEcTypeTransport: number;
	xEcProductFamily: number;
	listCategories: Array<EbCategorie>;
	listCategoriesStr: string;
	listLabels: string;
	favori: boolean;
	nbrDoc;
	curentTimeRemainingInMilliSecond: number;
	timeRemaining: number;
	timeRemainingFf: number;
	dg: boolean;
	equipement: boolean;
	sensitive: boolean;
	dryIce: boolean;
	totalNbrParcel: number;
	totalWeight: number;
	totalVolume: number;
	xEcStatut: number;
	flagRecommendation: boolean;
	flagDocumentTransporteur: boolean;
	flagDocumentCustoms: boolean;
	flagTransportInformation: boolean;
	flagEbtrackTrace: boolean;
	xEcTypeDemande: number;
	xEcModeTransport: number;
	xEcIncoterm: number;
	libelleOriginCountry: string;
	libelleDestCountry: string;
	user: EbUser;
	refTransport: string;
	temperatureTransport: string;
	temperatureStorage: string;
	codeAnnulation: string;
	aboutTrAwbBol: string;
	aboutTrMawb: string;
	aboutTrFlightVesse: string;
	aboutTrCustomOffice: string;
	aboutTrEta: Date;
	aboutTrEtd: Date;
	aboutTrPickUp: Date;
	aboutTrFinalDelivery: Date;
	xEcCancelled: Date;
	dateCreation: Date;
	customerReference: string;
	preAlertInfoAboutTransportSent: boolean;
	dateDelivery: Date;
	xEcTypeCustomBroker: number;
	coutPrestationDouane: number;
	xEcBroker: EbUser;
	listCommandes: Array<EbCommande>;
	listTransporteurs: Array<EbUser>;
	xEbCostCenter: EbCostCenter;
	totalTaxableWeight: number;
	listMarchandises: Array<EbMarchandise>;
	ebDemandeFichierJointNum: Array<number> = new Array<number>();
	exEbDemandeTransporteurs: Array<ExEbDemandeTransporteur>;
	listDemandeQuote: Array<ExEbDemandeTransporteur>;
	exEbDemandeTransporteur: ExEbDemandeTransporteur;
	listEmailSendQuotation: string;
	xEbTransporteur: number;
	xEbTransporteurEtablissementNum: number;
	nomTransporteur: string;
	customFields: string;
	configPsl: string;

	numAwbBol: string;
	flightVessel: string;
	datePickupTM: Date;
	etd: Date;
	finalDelivery: Date;
	eta: Date;
	customsOffice: string;
	mawb: string;
	xEbUserTransportInfoMaj: EbUser;

	codePslCourant: MTEnum;
	listEbTracing: Array<EbTracing>;
	flagEbInvoice: boolean;

	xEbEtablissement: EbEtablissement;
	listCustomsFields: Array<IField>;
	listincoterm: Array<keyValue>;
	sendQuotation: Boolean = false;
	statusQuote: number;

	cancelled: boolean;
	xecCurrencyInvoice: EcCurrency;
	listcurrency: Array<EcCurrency>;
	fournisseurReference: string;
	instruction: string;

	serviceOrigin: string;
	entiteOrigin: string;
	commandeNum: string;
	codeCmd: string;

	etatCommande: number;
	dateEtatCommande: Date;
	dateCommande: any;
	listEbDemandeFichierJointNum: Array<number>;

	prMontantHT: number;
	prWeight: number;
	prNumberOfUnits: number;

	dateNegotiation: Date;

	dateEstimee: Date;


	dateRamassage: Date;

	dateReception: Date;

	dateDepart: Date;

	dateArrivee: Date;

	dateDouane: Date;

	dateLivraison: Date;

	numReception: string;
	facture: string;
	numFacture: number;


	motif: string;

	dateCommandeSTR: string;

	xEcTypeFlux: TypeFlux;
	xEbAgence: EbEtablissement;
	constructor() {
		this.ebDemandeNum = null;
		this.nbReminderSent = null;
		this.ebPartyOrigin = new EbParty();
		this.ebPartyNotif = new EbParty();
		this.ebPartyDest = new EbParty();
		this.dateReadyForPickup = null;
		this.dateMaj = null;
		this.datePickup = null;
		this.dateCreation = null;
		this.dateEnvoiQuotation = null;
		this.insurance = null;
		this.insuranceValue = null;
		this.city = null;
		this.commentMytower = null;
		this.commentChargeur = null;
		this.dateOfGoodsAvailability = null;
		this.dateOfArrival = null;
		this.xEcTypeTransport = null;
		this.xEcProductFamily = null;
		this.listCategories = new Array<EbCategorie>();
		this.listCategoriesStr = "";
		this.listLabels = "";
		this.favori = null;
		this.curentTimeRemainingInMilliSecond = null;
		this.timeRemaining = null;
		this.timeRemainingFf = null;
		this.dg = null;
		this.equipement = null;
		this.sensitive = null;
		this.dryIce = null;
		this.totalNbrParcel = null;
		this.totalWeight = null;
		this.totalVolume = null;
		this.xEcStatut = DemandeStatus.RECOMMENDATION;
		this.flagRecommendation = null;
		this.flagDocumentCustoms = null;
		this.flagDocumentTransporteur = null;
		this.flagTransportInformation = null;
		this.xEcTypeDemande = null;
		this.xEcModeTransport = null;
		this.xEcIncoterm = null;
		this.libelleOriginCountry = null;
		this.libelleDestCountry = null;
		this.user = null;
		this.refTransport = null;
		this.temperatureTransport = null;
		this.temperatureStorage = null;
		this.codeAnnulation = null;
		this.aboutTrAwbBol = null;
		this.aboutTrMawb = null;
		this.aboutTrFlightVesse = null;
		this.aboutTrCustomOffice = null;
		this.aboutTrEta = null;
		this.aboutTrEtd = null;
		this.aboutTrPickUp = null;
		this.aboutTrFinalDelivery = null;
		this.xEcCancelled = null;
		this.customerReference = null;
		this.preAlertInfoAboutTransportSent = null;
		this.dateDelivery = null;
		this.xEcTypeCustomBroker = null;
		this.coutPrestationDouane = null;
		this.xEcBroker = null;
		this.listCommandes = new Array<EbCommande>();
		this.listTransporteurs = new Array<EbUser>();
		this.totalTaxableWeight = null;
		this.listMarchandises = new Array<EbMarchandise>();
		this.ebDemandeFichierJointNum = new Array<number>();
		this.listDemandeQuote = new Array<ExEbDemandeTransporteur>();
		this.exEbDemandeTransporteurs = new Array<ExEbDemandeTransporteur>();
		this.exEbDemandeTransporteur = new ExEbDemandeTransporteur();
		this.listEmailSendQuotation = "";
		this.xEbTransporteur = null;
		this.xEbTransporteurEtablissementNum = null;
		this.nomTransporteur = null;
		this.customFields = null;
		this.configPsl = null;
		this.numAwbBol = null;
		this.flightVessel = null;
		this.datePickupTM = null;
		this.etd = null;
		this.finalDelivery = null;
		this.eta = null;
		this.customsOffice = null;
		this.mawb = null;
		this.codePslCourant = null;
		this.listEbTracing = new Array<EbTracing>();
		this.xEbEtablissement = new EbEtablissement();
		this.listCustomsFields = new Array<IField>();
		this.sendQuotation = false;
		this.xEbUserTransportInfoMaj = null;
		this.statusQuote = null;
		this.cancelled = null;
		this.xecCurrencyInvoice = new EcCurrency();
		this.listcurrency = new Array<EcCurrency>();
		this.fournisseurReference = null;
		this.instruction = null;
		this.serviceOrigin = null;
		this.entiteOrigin = null;
		this.commandeNum = null;
		this.codeCmd = null;
		this.prMontantHT = null;
		this.prWeight = null;
		this.prNumberOfUnits = null;
		this.etatCommande = null;
		this.dateEtatCommande = null;
		this.listEbDemandeFichierJointNum = new Array<number>();
		this.dateCommande = null;

		this.dateNegotiation = null;

		this.dateEstimee = null;

		this.dateRamassage = null;

		this.dateReception = null;

		this.dateDepart = null;

		this.dateArrivee = null;

		this.dateDouane = null;

		this.dateLivraison = null;

		this.numReception = null;
		this.facture = null;
		this.numFacture = null;


		this.motif = null;
		this.dateCommandeSTR = null;
		this.xEcTypeFlux = null;
		this.xEbAgence = new EbEtablissement();
	}

	clone() {
		return JSON.parse(JSON.stringify(this))
	}

	cloneData(data) {
		this.ebDemandeNum = data.ebDemandeNum;
		this.nbReminderSent = data.nbReminderSent;
		this.ebPartyOrigin = EbParty.copyPartyJustId(data.ebPartyOrigin) || new EbParty();
		this.ebPartyNotif = EbParty.copyPartyJustId(data.ebPartyNotif) || new EbParty();
		this.ebPartyDest = EbParty.copyPartyJustId(data.ebPartyDest) || new EbParty();
		this.dateReadyForPickup = data.dateReadyForPickup;
		this.dateMaj = data.dateMaj;
		this.datePickup = data.datePickup;
		this.dateCreation = data.dateCreation;
		this.dateEnvoiQuotation = data.dateEnvoiQuotation;
		this.insurance = data.insurance;
		this.insuranceValue = data.insuranceValue;
		this.city = data.city;
		this.commentMytower = data.commentMytower;
		this.commentChargeur = data.commentChargeur;
		this.dateOfGoodsAvailability = data.dateOfGoodsAvailability;
		this.dateOfArrival = data.dateOfArrival;
		this.xEcTypeTransport = data.xEcTypeTransport;
		this.xEcProductFamily = data.xEcProductFamily;
		this.listCategories = data.listCategories || new Array<EbCategorie>();
		this.listCategoriesStr = data.listCategoriesStr || '';
		this.listLabels = data.listLabels || '';
		this.favori = data.favori;
		this.curentTimeRemainingInMilliSecond = data.curentTimeRemainingInMilliSecond;
		this.timeRemaining = data.timeRemaining;
		this.timeRemainingFf = data.timeRemainingFf;
		this.dg = data.dg;
		this.equipement = data.equipement;
		this.sensitive = data.sensitive;
		this.dryIce = data.dryIce;
		this.totalNbrParcel = data.totalNbrParcel;
		this.totalWeight = data.totalWeight;
		this.totalVolume = data.totalVolume;
		this.xEcStatut = data.xEcStatut;
		this.flagRecommendation = data.flagRecommendation;
		this.flagDocumentCustoms = data.flagDocumentCustoms;
		this.flagDocumentTransporteur = data.flagDocumentTransporteur;
		this.flagTransportInformation = data.flagTransportInformation;
		this.xEcTypeDemande = data.xEcTypeDemande;
		this.xEcModeTransport = data.xEcModeTransport;
		this.xEcIncoterm = data.xEcIncoterm;
		this.libelleOriginCountry = data.libelleOriginCountry;
		this.libelleDestCountry = data.libelleDestCountry;
		this.user = data.user;
		this.refTransport = data.refTransport;
		this.temperatureTransport = data.temperatureTransport;
		this.temperatureStorage = data.temperatureStorage;
		this.codeAnnulation = data.codeAnnulation;
		this.aboutTrAwbBol = data.aboutTrAwbBol;
		this.aboutTrMawb = data.aboutTrMawb;
		this.aboutTrFlightVesse = data.aboutTrFlightVesse;
		this.aboutTrCustomOffice = data.aboutTrCustomOffice;
		this.aboutTrEta = data.aboutTrEta;
		this.aboutTrEtd = data.aboutTrEtd;
		this.aboutTrPickUp = data.aboutTrPickUp;
		this.aboutTrFinalDelivery = data.aboutTrFinalDelivery;
		this.xEcCancelled = data.xEcCancelled;
		this.customerReference = data.customerReference;
		this.preAlertInfoAboutTransportSent = data.preAlertInfoAboutTransportSent;
		this.dateDelivery = data.dateDelivery;
		this.xEcTypeCustomBroker = data.xEcTypeCustomBroker;
		this.coutPrestationDouane = data.coutPrestationDouane;
		this.xEcBroker = data.xEcBroker;
		this.listCommandes = data.listCommandes || new Array<EbCommande>();
		this.listTransporteurs = data.listTransporteurs || new Array<EbUser>();
		this.totalTaxableWeight = data.totalTaxableWeight;
		this.listMarchandises = data.listMarchandises || new Array<EbMarchandise>();
		this.ebDemandeFichierJointNum = data.ebDemandeFichierJointNum || new Array<number>();
		this.exEbDemandeTransporteurs = data.exEbDemandeTransporteurs || new Array<ExEbDemandeTransporteur>();
		this.listDemandeQuote = data.listDemandeQuote || new Array<ExEbDemandeTransporteur>();
		this.exEbDemandeTransporteur = data.exEbDemandeTransporteur || new ExEbDemandeTransporteur();
		this.listEmailSendQuotation = data.listEmailSendQuotation || "";
		this.xEbTransporteur = data.xEbTransporteur;
		this.xEbTransporteurEtablissementNum = data.xEbTransporteurEtablissementNum;
		this.nomTransporteur = data.nomTransporteur;
		this.customFields = data.customFields;
		this.configPsl = data.configPsl;
		this.numAwbBol = data.numAwbBol;
		this.flightVessel = data.flightVessel;
		this.datePickupTM = data.datePickupTM;
		this.etd = data.etd;
		this.finalDelivery = data.finalDelivery;
		this.eta = data.eta;
		this.customsOffice = data.customsOffice;
		this.mawb = data.mawb;
		this.codePslCourant = data.codePslCourant;
		this.listEbTracing = data.listEbTracing;
		this.xEbEtablissement = data.xEbEtablissement;
		this.listCustomsFields = data.listCustomsFields;
		this.sendQuotation = data.sendQuotation;
		this.xEbUserTransportInfoMaj = data.xEbUserTransportInfoMaj;
		this.listincoterm = data.listincoterm;
		this.statusQuote = data.statusQuote;
		this.cancelled = data.cancelled;
		this.xecCurrencyInvoice = data.xecCurrencyInvoice;
		this.listcurrency = data.listcurrency;
		this.fournisseurReference = data.fournisseurReference;
		this.instruction = data.instruction;
		this.serviceOrigin = data.serviceOrigin;
		this.entiteOrigin = data.entiteOrigin;
		this.commandeNum = data.commandeNum;
		this.codeCmd = data.codeCmd;
		this.prMontantHT = data.prMontantHT;
		this.prWeight = data.prWeight;
		this.prNumberOfUnits = data.prNumberOfUnits;
		this.etatCommande = data.etatCommande;
		this.dateEtatCommande = data.dateEtatCommande;
		this.dateCommande = data.dateCommande;


		this.dateRamassage = data.dateRamassage;

		this.dateReception = data.dateReception;

		this.dateDepart = data.dateDepart;

		this.dateArrivee = data.dateArrivee;

		this.dateDouane = data.dateDouane;

		this.dateLivraison = data.dateLivraison;

		this.numReception = data.numReception;
		this.facture = data.facture;
		this.numFacture = data.numFacture;

		this.motif = data.motif;
		this.dateCommandeSTR = data.dateCommandeSTR;
		this.xEcTypeFlux = data.xEcTypeFlux;
		this.xEbAgence = data.xEbAgence;
	}
}



// WEBPACK FOOTER //
// ./src/app/classes/demande.ts